import React from 'react';
import {motion} from "framer-motion";

const ComparisonTable = ({openModal}) => {
    return (
        <div className='comparison-table-container'>
            <motion.div initial={{ opacity: 0, x: 200 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                        viewport={{ once: true }}
                        className="p-6 bg-blue-500 text-white rounded-lg shadow-lg">
                <div className="comparison-table">
                    <h2>Чому оренда - це <span>зручно</span>?</h2>
                    <table>
                        <thead>
                        <tr>
                            <th></th>
                            <th style={{color: 'red', fontSize: '28px'}}>Оренда</th>
                            <th style={{color: 'red', fontSize: '28px'}}>Купівля</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style={{fontWeight: '700'}}>PlayStation 4 Pro</td>
                            <td>від 190 грн/доба</td>
                            <td>Близько 15,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>PlayStation 5 Blu-Ray</td>
                            <td>від 320 грн/доба</td>
                            <td>Близько 19,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>PlayStation 5 Slim</td>
                            <td>від 320 грн/доба</td>
                            <td>Близько 22,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>Xbox Series S</td>
                            <td>від 250 грн/доба</td>
                            <td>Близько 15,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>Xbox Series X</td>
                            <td>від 300 грн/доба</td>
                            <td>Близько 20,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>Meta Quest 3 512 GB</td>
                            <td>від 350 грн/доба</td>
                            <td>Близько 27,000 грн</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>Гнучкість та оновлення</td>
                            <td>Легко змінити або повернути</td>
                            <td>Купівля нової консолі</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: '700'}}>Технічна підтримка</td>
                            <td>Безкоштовна заміна та підтримка</td>
                            <td>Платний ремонт та обслуговування</td>
                        </tr>
                        </tbody>
                    </table>
                    <button onClick={() => openModal()} className='red-btn table-btn'>Отримати консоль</button>
                </div>
            </motion.div>
        </div>
    );
};

export default ComparisonTable;